import {
    CLEAR_ALL,
    GET_IMPLEMENTATIONS_REQUEST,
    GET_IMPLEMENTATIONS_SUCCESS,
    GET_IMPLEMENTATIONS_ERROR,
    GET_IMPLEMENTATION_DETAIL_REQUEST,
    GET_IMPLEMENTATION_DETAIL_SUCCESS,
    CREATE_FAVORITE_SUCCESS,
    CREATE_FAVORITE_ERROR,
    REMOVE_FAVORITE_SUCCESS,
    REMOVE_FAVORITE_ERROR,
    GET_FAVORITES_REQUEST,
    GET_FAVORITES_SUCCESS,
    GET_FAVORITES_ERROR,
    GET_LICENSES_REQUEST,
    GET_LICENSES_SUCCESS,
    GET_LICENSES_ERROR,
    SET_IMPLEMENTATION_DETAIL_PARAMETER,
    SET_IMPLEMENTATION_DETAIL_TRAITS,
} from 'constants/ActionTypes';

const initialState = {
    list: [],
    current: {},
    listLoading: false,
    currentLoading: false,
    licenses: [],
    licensesLoading: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_IMPLEMENTATIONS_REQUEST:
            return {
                ...state,
                listLoading: true,
            };
        case GET_IMPLEMENTATIONS_SUCCESS:
            return {
                ...state,
                listLoading: false,
                list: action.payload.map((obj) => ({
                    ...obj,
                    code: `${obj.id}-${obj.name}`.toUpperCase(),
                })),
            };
        case GET_IMPLEMENTATIONS_ERROR:
            return {
                ...state,
                listLoading: false,
                list: [],
            };
        case GET_IMPLEMENTATION_DETAIL_REQUEST:
            return {
                ...state,
                current: {},
                currentLoading: true,
            };
        case GET_IMPLEMENTATION_DETAIL_SUCCESS:
            return {
                ...state,
                current: { ...state.current, ...action.payload },
                currentLoading: false,
            };
        case SET_IMPLEMENTATION_DETAIL_PARAMETER:
            return {
                ...state,
                current: {
                    ...state.current,
                    parameters: {
                        ...state.current.parameters,
                        [action.payload.key]: action.payload.value,
                    },
                },
            };
        case SET_IMPLEMENTATION_DETAIL_TRAITS:
            return {
                ...state,
                current: {
                    ...state.current,
                    traits: {
                        ...state.current.traits,
                        [action.payload.key]: action.payload.value,
                    },
                },
            };
        case CREATE_FAVORITE_SUCCESS: {
            const obj = state.list.find((item) => item.id === action.payload);
            if (obj) {
                obj.favorite = true;
            }
            return {
                ...state,
                list: [...state.list],
            };
        }
        case CREATE_FAVORITE_ERROR:
            return {
                ...state,
            };
        case REMOVE_FAVORITE_SUCCESS: {
            const obj = state.list.find((item) => item.id === action.payload);
            if (obj) {
                obj.favorite = false;
            }
            return {
                ...state,
                list: [...state.list],
            };
        }
        case REMOVE_FAVORITE_ERROR:
            return {
                ...state,
            };
        case GET_FAVORITES_REQUEST:
            return {
                ...state,
                listLoading: true,
            };
        case GET_FAVORITES_SUCCESS:
            return {
                ...state,
                listLoading: false,
                list: action.payload.map((obj) => ({
                    ...obj,
                    code: `${obj.id}-${obj.name}`.toUpperCase(),
                })),
            };
        case GET_FAVORITES_ERROR:
            return {
                ...state,
                listLoading: false,
                list: [],
            };
        case GET_LICENSES_REQUEST:
            return {
                ...state,
                licensesLoading: true,
            };
        case GET_LICENSES_SUCCESS:
            return {
                ...state,
                licensesLoading: false,
                licenses: action.payload,
            };
        case GET_LICENSES_ERROR:
            return {
                ...state,
                licensesLoading: false,
                licenses: [],
            };
        case CLEAR_ALL:
            return initialState;
        default:
            // need this for default case
            return {
                ...state,
            };
    }
}
